import {useContext, createContext, useState, useEffect, useCallback, useMemo} from 'react';
import { apiFetch, clearToken } from '../utils/api';

const AuthContext = createContext({
    isAuthenticated: false
});

export function AuthProvider({children}) {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isLoggedIn') === 'true' && !!localStorage.getItem('auth_token'));
    const [user, setUser] = useState({});

    const checkAuth = useCallback(async () => {
      if (!localStorage.getItem('auth_token')) {
        setIsAuthenticated(false);
        localStorage.setItem('isLoggedIn', 'false');
        return;
      }
      try {
        const data = await apiFetch('/api/auth/me');
        if (data.status) {
          setUser(data.data);
          setIsAuthenticated(true);
          localStorage.setItem('isLoggedIn', 'true');
        } else {
          setIsAuthenticated(false);
          localStorage.setItem('isLoggedIn', 'false');
          clearToken();
        }
      } catch (error) {
        console.error('Error al verificar autenticación:', error);
        setIsAuthenticated(false);
        localStorage.setItem('isLoggedIn', 'false');
      }
    }, []);

    useEffect(() => {
      checkAuth();
    }, [checkAuth]);

    const value = useMemo(() => ({
      isAuthenticated,
      setIsAuthenticated,
      checkAuth,
      user,
    }), [isAuthenticated, checkAuth, user]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);